import { render, staticRenderFns } from "./AddBankCard.vue?vue&type=template&id=6f491a5f&"
import script from "./AddBankCard.vue?vue&type=script&lang=ts&"
export * from "./AddBankCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddBankCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports